import { type RegisterDto, type LoginDto } from '@pokefolio/types';
import type { AuthUser } from '@pokefolio/types';

import { api, rememberSessionToken } from './api';

interface AuthResponse {
  user: AuthUser;
  /** Absent in cookie-only mode (see rememberSessionToken). */
  accessToken?: string;
}

export const authService = {
  async register(data: RegisterDto): Promise<{ message: string }> {
    const response = await api.post<{ message: string }>('/auth/register', data);
    return response.data;
  },

  async login(data: LoginDto): Promise<AuthResponse> {
    const response = await api.post<AuthResponse>('/auth/login', data);
    rememberSessionToken(response.data.accessToken);
    return response.data;
  },

  /** Always ends the local session, even when the server one is already gone. */
  async logout(): Promise<void> {
    try {
      await api.post('/auth/logout');
    } finally {
      localStorage.removeItem('access_token');
    }
  },

  async getMe(): Promise<AuthUser> {
    const response = await api.get<AuthUser>('/auth/me');
    return response.data;
  },

  // ✅ Vérifier l'authentification en appelant /auth/me
  async isAuthenticated(): Promise<boolean> {
    try {
      await this.getMe();
      return true;
    } catch {
      return false;
    }
  },
};
